import { createContext, useContext, type ReactNode } from 'react';
import type { Perfil } from '../api';

const Contexto = createContext<Perfil | null>(null);

export function ProveedorSesion({ perfil, children }: { perfil: Perfil; children: ReactNode }) {
  return <Contexto.Provider value={perfil}>{children}</Contexto.Provider>;
}

/** El perfil de quien está usando el sistema. Sólo dentro del layout. */
export function useSesion(): Perfil {
  const perfil = useContext(Contexto);
  if (!perfil) throw new Error('useSesion fuera de la sesión iniciada');
  return perfil;
}

/**
 * Si el usuario puede modificar el depósito o sólo mirarlo. El servidor lo
 * verifica igual en cada ruta; esto es para no ofrecer botones que van a fallar.
 */
export const usePuedeOperar = () => useSesion().rol !== 'operador_zf';

export const useEsAdmin = () => useSesion().rol === 'admin';
